/**
 * @name 抽屉
 */
import base from '../../base';
import Drawer from './drawer';

Drawer.install = function(Vue) {
  Vue.use(base);
  Vue.component(Drawer.name, Drawer);
};

export default Drawer;
